module.exports = __webpack_public_path__ + "img/payment_pc_10.e52b7144.png";